"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _componentsBase = require("@telus-uds/components-base");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Takes a string content and marks up all the links in it by wrapping them
 * in `Link` component.
 */const generateLinks = content => {
  const linkRegex = /<\s*a([^>]*)>(.*?)<\s*\/\s*a>/g;
  const attributeRegex = /(\w+)\s*=\s*((["'])(.*?)\3|(?=\s|\/>))/g;
  const parts = content.split(linkRegex);
  if (parts.length === 1) {
    return parts;
  }

  // Start with first anchor text, attributes will be in the previous part
  for (let i = 2; i < parts.length; i += 3) {
    const o = {};
    // Get attributes from previous part
    const attributes = parts[i - 1].trim();

    // Create object from attributes
    const matchedAttributes = attributes.match(attributeRegex);
    if (matchedAttributes) {
      matchedAttributes.forEach(attribute => {
        const split = attribute.split('=');
        o[split[0]] = split[1].substr(1, split[1].length - 2);
      });
    }
    // Remove anchor attributes from parts
    parts[i - 1] = undefined;
    // Replace anchor text with Link in parts
    parts[i] = /*#__PURE__*/(0, _react.createElement)(_componentsBase.Link, {
      ...o,
      key: i
    }, parts[i]);
  }
  return parts;
};

/**
 * Takes an array of strings and in each element replaces the breaks with `<br>` tags.
 */
const generateBreaks = parts => {
  const breakRegex = /<br\s?\/*>/g;
  const partsWithBreaks = parts;
  for (let i = 0; i < partsWithBreaks.length; i += 1) {
    if (typeof partsWithBreaks[i] === 'string' && partsWithBreaks[i].search(breakRegex) !== -1) {
      const toSplit = partsWithBreaks[i].split(breakRegex);
      for (let x = 1; x < toSplit.length; x += 2) {
        toSplit.splice(x, 0, /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}, `break-${i}-${x}`));
      }
      partsWithBreaks[i] = toSplit;
    }
  }
  return partsWithBreaks;
};
const renderStructuredContent = content => {
  if (typeof content !== 'string') {
    return content;
  }
  return generateBreaks(generateLinks(content));
};
var _default = exports.default = renderStructuredContent;